var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"home-banner"}},[_c('b-container',[_c('b-row',{attrs:{"id":"banner-box","align-v":"center"}},[_c('Banner')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }